import styled, { css } from 'styled-components';
import { black, white, gray75 } from '@spotify-internal/encore-foundation';
import { tabFocus } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.app === 'dark';
};

var backgroundColorDefault = function backgroundColorDefault(props) {
  return isDarkTheme(props) ? black : white;
};

export default styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1g74f58-0"
})(["background:", ";display:flex;flex-direction:column;left:0;min-height:100%;position:absolute;top:0;width:100%;", ";"], function (props) {
  return props.backgroundColor || backgroundColorDefault(props);
}, function (props) {
  return isDarkTheme(props) && css(["color:", ";a[href]:not([class]){color:", ";text-decoration:none;&:hover,&:focus{color:", ";text-decoration:underline;}&:active{color:", ";}&:focus{", ";}}"], gray75, white, white, white, tabFocus());
});